__turbopack_context__.v({
  "buttons": "share-tools-module__Ez75ha__buttons",
  "exports": "share-tools-module__Ez75ha__exports",
  "fallback": "share-tools-module__Ez75ha__fallback",
  "status": "share-tools-module__Ez75ha__status",
  "tools": "share-tools-module__Ez75ha__tools",
});
